import React, { Component } from "react";
import { connect } from "react-redux";
import ShapedBox from "../../common/ShapedBox";
import {
    fetchWorkOrders,
} from '../../api/checkIn';
import { path, T } from "ramda";
import './style.css';
import Preloader from "../../common/Preloader";
import Breadcrumbs from "../../common/Breadcrumbs";
import { fetchWorker } from "../../api/employees";
import config from "../../config";

class SelectWorkOrder extends Component {
    componentDidMount() {
        const { customerID } = path(['match', 'params'], this.props);
        const { userid } = this.props.location.state;
        this.props.getWorkOrders(customerID);
        this.props.loadWorker(userid);
        window.scrollTo(0, 0);
    }


    render() {
        const { userid } = this.props.location.state;

        const workOrders = path(['checkIn', 'workOrders'], this.props);
        const worker = path(['employees', 'worker'], this.props);
        const workerFullname = worker ? `${worker.firstname} ${worker.lastname}` : '';

        return (
            <div>
                <Breadcrumbs
                    list={[
                        { url: '/pages/check-in', icon: 'perm_contact_calendar', name: 'Check In' },
                        { url: '/pages/check-in', icon: 'person', name: `${workerFullname}` },
                        { url: '/pages/check-in', icon: 'assignment', name: 'New Work' },
                    ]}
                />
                <div className="card">
                    <div className="card-header rounded-top">Choose Work Order</div>
                    <div className="card-block">
                        <div className="d-flex justify-content-end align-items-center">
                            <div>
                                <button
                                    className="btn btn-rounded btn-icon ui-btn pull-right m-l-10"
                                    onClick={() => this.props.history.push(`/pages/check-in/${userid}`)}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-rounded btn-icon ui-btn pull-right"
                                    onClick={() => this.props.history.goBack()}
                                >
                                    Back
                                </button>
                            </div>
                        </div>
                        {!!workOrders ?
                            <div className="d-flex justify-content-start flex-wrap list-container">
                                {workOrders.map((task, index) => {
                                    return (
                                        <ShapedBox onClick={() => this.props.history.push(`/pages/check-in/378/activity`,
                                            { ...this.props.location.state, task })}>
                                            <div className="h-100 p-3 pointer">
                                                <div className="h5">{task.task_name}</div>
                                                <br />
                                                <div className="text-default">
                                                    <div>Description:</div>
                                                    <div className="fixed-lines">{task.description}</div>
                                                    <div className="text-center">
                                                      {task.preview_img ? <img className='user-avatar' src={`${config.apiEndpoint}/uploads/attachments/${task.task_id}/${task.preview_img}`} /> : ''}
                                                    </div>
                                                </div>
                                            </div>
                                        </ShapedBox>
                                    )
                                })}
                            </div>
                            :
                            <Preloader
                                show={true}
                                type={'circle'}
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }
};

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToProps = (dispatch) => {
    return {
        getWorkOrders: (customerID) => {
            fetchWorkOrders(customerID)(dispatch);
        },
        loadWorker: (workerId) => {
            fetchWorker(workerId)(dispatch);
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectWorkOrder);



// WEBPACK FOOTER //
// ./src/containers/SelectWorkOrder/index.js